import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { categoriTypes, color } from "../StaticData.js";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import moment from "moment/moment";
import {
  addFillerStock,
  getCubeBelts,
  getInclusion,
  getUserApi,
  updateGraderAssignStock,
} from "api";
import { withTranslation } from "react-i18next";
import ShowDiffenence from "components/Common/ShowDiffenence";

class SummaryShow extends Component {
  constructor(props) {
    console.log(props);

    super(props);
    this.state = {
      ...this.props,

      stockList:
        props?.location?.query.isEdit == 3
          ? props?.location?.query.data.graderStock.stockGraderInWards.sort(
              (a, b) =>
                a.stockDataEntryInWard.srNo - b.stockDataEntryInWard.srNo
            )
          : [],
      props: props?.location?.query,
    };
  }

  render() {
    document.title = "filler flow";
    //meta title
    this.columns1 = [
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
        formatter: (cell, row, rowIndex) => {
          row.pieces = row.stockDataEntryInWard.pieces;
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        // formatter: (cell, row, rowIndex) => {
        //   return row.stockDataEntryInWard.pieces;
        // },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        formatter: (cell, row, rowIndex) => {
          return row.stockDataEntryInWard.weight + " CT";
        },
      },

      {
        dataField: "iColorId",
        text: `${this.props.t("Color")}`,
        footer: "",
        editable: false,
        editor: {
          type: Type.SELECT,
          options: color,
        },
        formatter: (cell, row) => {
          return color.find(x => x.value == cell)?.label;
        },
      },

      {
        dataField: "shape",
        text: `${this.props.t("Shape")}`,
        type: "text",
        footer: "",
        formatter: (cell, row) => {
          return cell.name;
        },
      },
      {
        dataField: "remarks",
        text: `${this.props.t("Inward Remarks")}`,
        footer: "",
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person")}`,
        footer: "",
      },

      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        type: "text",
        footer: "",
        formatter: (cell, row) => {
          if (
            row.assignGraderToFillerInWards &&
            Array.isArray(row.assignGraderToFillerInWards) &&
            row.assignGraderToFillerInWards.length > 0
          ) {
            return row.assignGraderToFillerInWards.reduce((prev, current) => {
              return prev.cycle > current.cycle ? prev : current;
            }).process.name;
          } else {
            return "NA";
          }
        },
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        type: "text",
        footer: "",
        formatter: (cell, row) => {
          if (
            row.assignGraderToFillerInWards &&
            Array.isArray(row.assignGraderToFillerInWards) &&
            row.assignGraderToFillerInWards.length > 0
          ) {
            return row.assignGraderToFillerInWards.reduce((prev, current) => {
              return prev.cycle > current.cycle ? prev : current;
            }).cycle;
          } else {
            return "NA";
          }
        },
      },
      {
        dataField: "status",
        text: `${this.props.t("Stauts")}`,
        type: "text",
        footer: "",
        formatter: (cell, row) => {
          if (row.ar == false) {
            return "Cancel";
          } else if (
            row.assignGraderToFillerInWards &&
            Array.isArray(row.assignGraderToFillerInWards) &&
            row.assignGraderToFillerInWards.length > 0
          ) {
            let temp = row.assignGraderToFillerInWards.reduce(
              (prev, current) => {
                return prev.cycle > current.cycle ? prev : current;
              }
            );
              if (temp.stockFillerInWard && temp.stockFillerInWard.cubeInformation && temp.stockFillerInWard.cubeInformation.cubeBelt) {
                if (
                  temp.stockFillerInWard.cubeInformation.cubeBelt
                    .machineOperatorStock 
                ) {
                  return temp.stockFillerInWard.cubeInformation.cubeBelt
                    .machineOperatorStock.graderStatus == "NA"
                    ? temp.stockFillerInWard.cubeInformation.cubeBelt.cubeId
                    : "Done";
                } else {
                  return "Pending";
                }
              } else {
                return "Filler";
              }
          } else {
            return "NA";
          }
        },
      },
    ];
    document.title = "summary show";
    const { history } = this.props;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Summary Show")} />
            <Card>
              <div className="row px-3 pt-4">
                <div>
                  <h3 className="fw-bold pb-3 text-black">
                    {this.props.t("Summary")}
                  </h3>
                </div>

                <div className="table-responsive">
                  <BootstrapTable
                    classes="foo"
                    keyField="id"
                    headerClasses="background-light fs-5"
                    footerClasses="background-light fs-5"
                    bootstrap4={true}
                    data={this.state.stockList}
                    columns={this.columns1}
                  />
                </div>
              </div>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(SummaryShow);
